import React from 'react'
import Layout from 'src/components/Layout/Layout'
import Wrapper from 'src/components/Wrapper/Wrapper'
import 'src/styles/global.scss'

export const wrapRootElement = Wrapper

export const wrapPageElement = ({ element, props }) => {
  // props provide same data to Layout as Page element will get
  // including location, data, etc - you don't need to pass it
  return <Layout {...props}>{element}</Layout>
}

const supportsWebp = () => {
  try {
    const canvas = document.createElement('canvas')
    if (!canvas.getContext || !canvas.getContext('2d')) {
      return false
    }
    return canvas.toDataURL('image/webp').indexOf('data:image/webp') === 0
  } catch (e) {
    return false
  }
}

export const onClientEntry = () => {
  // IntersectionObserver polyfill for older Safari/IE
  if (typeof window.IntersectionObserver === `undefined`) {
    require(`intersection-observer`)
  }

  if (document) {
    const htmlEL = document.documentElement
    htmlEL.classList.add('webp-checked')
    if (supportsWebp()) {
      htmlEL.classList.add('support-webp')
    }
  }
}
